import MarqueeRibbon from "react-fast-marquee";
import { useReducedMotion } from "framer-motion";
import { MARQUEE_ITEMS } from "@/data/content";

const Items = () => (
    <>
        {MARQUEE_ITEMS.map((item) => (
            <span key={item} className="mx-8 flex items-center gap-16">
                <span className="text-outline whitespace-nowrap font-display text-4xl font-black uppercase tracking-tighter sm:text-5xl md:text-6xl">
                    {item}
                </span>
                <span className="font-mono2 text-2xl text-neon/60" aria-hidden="true">//</span>
            </span>
        ))}
    </>
);

export const Marquee = () => {
    const reduce = useReducedMotion();
    return (
        <div
            data-testid="skills-marquee"
            aria-hidden="true"
            className="overflow-hidden border-y border-white/5 bg-black/40 py-10 md:py-14"
        >
            {reduce ? (
                <div className="flex flex-wrap justify-center gap-y-4">
                    <Items />
                </div>
            ) : (
                <MarqueeRibbon speed={32} gradient={false} pauseOnHover>
                    <Items />
                </MarqueeRibbon>
            )}
        </div>
    );
};
